<template>
  <div>
    <v-container>
      <v-row justify="center" class="center">
        <v-col
        sm="12"
        lg="4"
        >
          <v-row>
            <v-col cols="12">
              <div class="secondary--text text-uppercase text-h4 text-md-h2 text-center">
                <span class="font-weight-light font-italic font-bold">Rapid</span>
                <span> Quote</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-form>
                <v-card class="primary">
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-col cols="12">
                          <div class="headline secondary--text text-md-h3 text-xs-h5 text-center">Reset Password</div>
                        </v-col>
                        <v-col cols="12" v-if="$vuetify.breakpoint.smAndUp">
                          <div class="secondary--text text-md-subtitle-1 text-center">Check your email for the seven digit code.</div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            id="code"
                            color="secondary"
                            dark
                            v-model="token"
                            autocomplete="off"
                            label="Code"
                            type="text"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            color="secondary"
                            dark
                            append-icon="mdi-lock" 
                            v-model="password" 
                            label="Enter New Password"
                            autocomplete="off"
                            :type="fieldTypes.password"
                            required
                            name="password"
                            @input="handleType"
                            @blur="handleType"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            color="secondary"
                            dark
                            append-icon="mdi-lock"
                            autocomplete="off"
                            v-model="repeatPassword"
                            label="Repeat New Password" 
                            :type="fieldTypes.password"
                            required
                            name="password"
                            @input="handleType"
                            @blur="handleType"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-btn color="secondary primary--text" class="mr-4" block large @click="submit">
                          Change Password
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-container>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-btn color="light-blue lighten-1" block text to="/" class="mr-4">back to login</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
  // import { validationMixin } from 'vuelidate';
  // import { required, minLength, sameAs } from 'vuelidate/lib/validators';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    // mixins: [validationMixin],
    
    data: () => ({
      token: '',
      password: '',
      repeatPassword: '',
      fieldTypes: {
        password: "text",
      }
    }),
    
    computed: {
      ...mapGetters ({
        loginContext: 'loginContext'
      }),
    },

    methods: {
      ...mapActions(['newPass']),
      submit () {
        // this.$v.$touch();
        let authData = {
          token: this.token,
          password: this.password
        };
        this.newPass(authData);
      },
      handleType(event){
        const { srcElement, type } = event;
        if (!srcElement) return;
        const { name, value } = srcElement;
        if (type === 'blur' && !value) {
          this.fieldTypes[name] = 'text'
        } else {
          this.fieldTypes[name] = 'password'
        }
      },
    },
  };
</script>

<style scoped>
    .center {
      margin-top:1vh;
    }
    .ResetForgotPass {
      background: radial-gradient(#505CBE, #282E5F);
      height: 100vh;
    }
</style>